import React from 'react';
import { useParams } from 'react-router-dom';
import { Shield, ArrowRight } from 'lucide-react';
import { bankData, type BankId } from '../../data/bankData';

const BankDeposits = () => {
  const { bankId } = useParams<{ bankId: string }>();
  const bank = bankData[bankId as BankId];

  if (!bank) {
    return <div>Banka bulunamadı</div>;
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="bg-gradient-to-b from-[#F7BA45]/20 to-slate-50 py-12">
        <div className="container mx-auto px-4">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-6 mb-8">
              <img 
                src={bank.logo} 
                alt={bank.name}
                className="h-16 object-contain"
              />
              <div>
                <h1 className="text-3xl font-bold text-slate-800 mb-2">
                  {bank.name} Mevduat Ürünleri
                </h1>
                <p className="text-slate-600">
                  Size en uygun {bank.name} mevduat ürününü seçin, hemen başvurun
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {bank.products.deposits.map((deposit, index) => (
                <div 
                  key={index}
                  className="bg-white rounded-xl border border-slate-200 overflow-hidden hover:border-[#F7BA45]/50 transition-all duration-300 hover:shadow-lg"
                >
                  <div className="p-6">
                    <h3 className="text-xl font-semibold text-slate-800 mb-6">{deposit.title}</h3>
                    
                    <div className="grid grid-cols-2 gap-4 mb-6">
                      <div className="bg-slate-50 rounded-xl p-4">
                        <div className="text-sm text-slate-500 mb-1">Faiz Oranı</div>
                        <div className="font-semibold text-slate-800">%{deposit.rate}</div>
                      </div>
                      <div className="bg-slate-50 rounded-xl p-4">
                        <div className="text-sm text-slate-500 mb-1">Vade</div>
                        <div className="font-semibold text-slate-800">{deposit.term} Gün</div>
                      </div>
                    </div>

                    <div className="space-y-3 mb-6">
                      {deposit.features.map((feature, i) => (
                        <div key={i} className="flex items-center gap-2 text-sm text-slate-600">
                          <Shield size={16} className="text-[#F7BA45]" />
                          <span>{feature}</span>
                        </div>
                      ))}
                    </div>

                    <button className="w-full bg-[#F7BA45] hover:bg-[#e5ac3d] text-slate-900 px-6 py-3 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 shadow-md hover:shadow-lg">
                      HEMEN BAŞVUR
                      <ArrowRight size={18} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankDeposits;